import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./app/App";
import { store } from "./app/store";
import { queryClient } from "./lib/queryClient";
import {
  cleanReloadQueryParam,
  installStaleChunkRecovery,
  logBuildBanner,
  markBootSuccessful,
  startVersionWatcher,
} from "./lib/appVersion";
import "./styles/index.css";

// Clean any temporary cache-busting query parameter left from an update reload.
cleanReloadQueryParam();

// Prints the build stamp so a live browser can be checked against the deploy.
logBuildBanner();

// Recover from chunks left behind by an older deploy. Installed before anything
// else so it is listening while the first lazy routes are still loading.
installStaleChunkRecovery();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root was not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </StrictMode>
);

// Notify the user when a newer build has been deployed to the server.
startVersionWatcher();

// If the app is still running after this long, the boot genuinely succeeded, so
// reset the recovery budget. The delay is what stops a reload loop.
window.setTimeout(markBootSuccessful, 15_000);
